/* eslint-disable react-native/no-inline-styles */
import {useNavigation} from '@react-navigation/native';
import {Button, Text} from '@ui-kitten/components';
import React from 'react';
import {
  Image,
  StyleSheet,
  TouchableOpacity,
  View,
  Dimensions,
  Platform,
} from 'react-native';
import {starBanner} from '../../../../../assets/images';
import {getImage} from '../../../../../helpers/general';
import {px, useIsLandscape} from '../../../../../utils';

const {width} = Dimensions.get('window');

const CustomCard = ({data, onClickRoute, cardProps, disabled, isSelected}) => {
  const navigation = useNavigation();
  const isLandscape = useIsLandscape();
  const {image, onPress, subtitle} = data;
  let primaryText = data[cardProps.primary];
  const secondaryText = data[cardProps.secondary];
  const {discount, disabled: actionDisabled} = data;

  if (cardProps.type === 'subject') {
    let subText = data[cardProps.subPrimary];
    if (subText && subText !== '') {
      primaryText += ` (${subText})`;
    }
  }

  const handleOnPress = () => {
    if (typeof onPress === 'function') {
      onPress(data);
    } else {
      navigation.navigate(onClickRoute, {data});
    }
  };

  return (
    <TouchableOpacity disabled={disabled} onPress={handleOnPress}>
      <View
        style={[
          styles.container,
          isLandscape
            ? {
                marginRight: px(36),
                marginBottom: px(49),
              }
            : {
                marginRight: px(10),
                marginBottom: px(12),
              },
          isSelected ? {borderColor: '#FF5722', borderWidth: 1} : undefined,

          actionDisabled ? styles.disabled : undefined,
        ]}>
        <View
          style={[styles.card, {backgroundColor: cardProps.backgroundColor}]}>
          <Image
            source={{uri: getImage(image)}}
            defaultSource={starBanner}
            resizeMode="contain"
            style={[styles.image]}
          />
        </View>
        {Boolean(primaryText) && (
          <Text style={styles.text1}>{primaryText}</Text>
        )}
        {Boolean(subtitle) && <Text style={styles.text2}>{subtitle}</Text>}
        {Boolean(secondaryText) && (
          <Text style={styles.text2}>{secondaryText}</Text>
        )}
        {Boolean(cardProps.buttonText) && (
          <Button
            onPress={handleOnPress}
            size="small"
            disabled={actionDisabled}
            style={[styles.button]}>
            {(evaProps) => (
              <Text {...evaProps} style={[evaProps.style, styles.buttonText]}>
                {cardProps.buttonText}
              </Text>
            )}
          </Button>
        )}
        {Boolean(discount) && (
          <Text style={styles.discountText}>* {discount}</Text>
        )}
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    width: px(width / 2 - 20),
    // height: px(260),
    padding: px(8),
    paddingBottom: px(25),
    borderRadius: 8,
    shadowColor: '#000',
    shadowOffset: {
      width: 2,
      height: 4,
    },
    shadowOpacity: 0.12,
    shadowRadius: 4.65,
    elevation: 2,
    ...Platform.select({
      web: {
        maxWidth: px(250),
      },
      ios: {
        borderColor: '#E5E5E5',
        borderWidth: 2,
      },
    }),
  },
  card: {
    paddingVertical: px(10),
    borderRadius: 8,
  },
  disabled: {
    opacity: 0.5,
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
  },
  image: {
    width: px(154),
    height: px(116),
    borderRadius: 8,
    marginHorizontal: 'auto',
  },
  text1: {
    marginTop: px(12),
    fontSize: px(16),
    fontWeight: '600',
    textAlign: 'center',
  },
  text2: {
    fontSize: px(14),
    marginTop: px(5),
    textAlign: 'center',
    textTransform: 'capitalize',
  },
  button: {
    marginTop: px(12),
  },
  buttonText: {
    fontWeight: 'bold',
    fontSize: px(14),
  },
  discountText: {
    fontSize: px(14),
    marginTop: px(10),
    textAlign: 'center',
    color: '#FF5722',
  },
});

export default CustomCard;
